@import '../../theme/mixins';
@import '../../theme/colors';

.root {
  @include label1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-transform: uppercase;
}

.pagesizeContainer {
  display: flex;
  align-items: center;
  margin-left: 10px;

  span {
    margin: 0 2px;
  }
}
.pagesizeContainer button,
.pageNavigation .pageNumber {
  @include label1;
  background-color: transparent;
  cursor: pointer;
  padding: 4px;
  text-align: center;
  font-family: var(--font-family__body);
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;

  &.active {
    background-color: $oceanBlue;
    color: $white;
  }
  &:disabled {
    cursor: default;
  }
}

.pageinputContainer {
  display: flex;
  align-items: center;
  form {
    min-width: 17px;
    width: fit-content;
    max-width: 20px;
    height: 18px;
    margin: 0;
    margin-left: 2px;

    & > div:first-child {
      margin: 0;
    }

    input {
      @include label1;
      padding: 2px 3px !important;
      text-align: center;
    }
  }
}

.pageNavigation ul {
  display: flex;
  align-items: center;
  margin: 0 4px;
  padding: 0;
  color: $oceanBlue;

  li {
    @include body2;
    display: flex;
    justify-content: center;
    align-items: center;

    .pageNumber {
      width: 100%;
      height: 100%;
      &:disabled {
        opacity: 0.7;
      }
    }
  }

  .activePage {
    background-color: $oceanBlue;
    color: $white;
  }
}
